import { apiClient, unwrap } from './client';
import type { ApiResponse, PagedResult } from '@/types/api';
import type {
  AddAppToProfileRequest,
  CreateProfileRequest,
  ProfileDto,
  ProfileListRequest,
  UpdateProfileAppRequest,
  UpdateProfileRequest,
} from '@/types/profile';

export const profilesApi = {
  list(request: ProfileListRequest = {}): Promise<PagedResult<ProfileDto>> {
    return unwrap(apiClient.get<ApiResponse<PagedResult<ProfileDto>>>('/profiles', { params: request }));
  },
  getById(id: number): Promise<ProfileDto> {
    return unwrap(apiClient.get<ApiResponse<ProfileDto>>(`/profiles/${id}`));
  },
  create(request: CreateProfileRequest): Promise<ProfileDto> {
    return unwrap(apiClient.post<ApiResponse<ProfileDto>>('/profiles', request));
  },
  update(id: number, request: UpdateProfileRequest): Promise<ProfileDto> {
    return unwrap(apiClient.put<ApiResponse<ProfileDto>>(`/profiles/${id}`, request));
  },
  deactivate(id: number): Promise<void> {
    return apiClient.delete(`/profiles/${id}`).then(() => undefined);
  },
  addApp(profileId: number, request: AddAppToProfileRequest): Promise<ProfileDto> {
    return unwrap(apiClient.post<ApiResponse<ProfileDto>>(`/profiles/${profileId}/apps`, request));
  },
  updateApp(profileId: number, profileAppId: number, request: UpdateProfileAppRequest): Promise<ProfileDto> {
    return unwrap(
      apiClient.put<ApiResponse<ProfileDto>>(`/profiles/${profileId}/apps/${profileAppId}`, request),
    );
  },
  removeApp(profileId: number, profileAppId: number): Promise<ProfileDto> {
    return unwrap(
      apiClient.delete<ApiResponse<ProfileDto>>(`/profiles/${profileId}/apps/${profileAppId}`),
    );
  },

  sync(id: number): Promise<void> {
    return apiClient.post(`/profiles/${id}/sync`).then(() => undefined);
  },
};
